import { render, staticRenderFns } from "./AddressBookImport.vue?vue&type=template&id=5abba0b0&scoped=true"
import script from "./AddressBookImport.vue?vue&type=script&lang=js"
export * from "./AddressBookImport.vue?vue&type=script&lang=js"
import style0 from "./AddressBookImport.vue?vue&type=style&index=0&id=5abba0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abba0b0",
  null
  
)

export default component.exports